import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { context } from "../../context/context";
export const Splash = ({component:Component}) => {
  const { state } = useContext(context);
  return state.isAuth ? <Redirect to="/" /> : <Component />;
};
